import React from 'react'
import PropTypes from 'prop-types'
import TextTruncate from 'react-text-truncate'
import numeral from 'numeral'

import Icon from 'Pods/Shared/Icon/Icon'
import FullReviewModal from 'Pods/Shared/Reviews/Components/FullReviewModal'
import { LessThanBreakpoint } from 'Utils/GetBreakpoint'
import IsCssSupported from 'Utils/IsCssSupported'
import imagePlaceholder from 'images/no_image_full.png'

import UserProjectsReviewMeta from './UserProjectsReviewMeta'
import UserProjectsReviewRate from './UserProjectsReviewRate'

class UserReview extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      isResponsive: false,
      isCoverImageSupported: IsCssSupported('objectFit'),
      imageSrc: props.attributes.image || '',
      review: {
        name: this.props.attributes.author,
        rating: this.props.attributes.score,
        title: this.props.attributes.title,
        content: this.props.attributes.comment,
        createdAt: this.props.attributes.createdAt,
        avatar: {},
      },
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.isResponsive = this.isResponsive.bind(this)
    this.handleImageErrored = this.handleImageErrored.bind(this)
  }

  componentDidMount() {
    this.isResponsive()

    window.addEventListener('resize', this.isResponsive)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.isResponsive)
  }

  handleImageErrored() {
    this.setState({ imageSrc: imagePlaceholder })
  }

  isResponsive() {
    this.setState({ isResponsive: LessThanBreakpoint('xl') })
  }

  toggleModal(event) {
    event.preventDefault()

    this.setState({ modalIsOpen: !this.state.modalIsOpen })
  }

  render() {
    const moreLink = (
      <span
        className="job-list-item__description-more link--secondary"
        onClick={this.toggleModal}
      >
        More
        <Icon type={['far', 'chevron-right']} className="u-ml10" />
      </span>
    )
    const price = !this.props.attributes.isPrivate && numeral(this.props.attributes.price).format('$0.00')
    let imageStyles = {}

    if (!this.state.isCoverImageSupported) {
      imageStyles = { backgroundImage: `url(${this.state.imageSrc})` }
    }

    return (
      <div className="card card--interactive job-list-item job-list-item--review">
        {this.props.attributes.isPrivate ? (
          <div className="user-review__private-placeholder">
            <Icon type={['fal', 'user-secret']} className="heading-48" />
          </div>
        ) : (
          <div className="user-review__image-wrapper">
            <div
              className={`image-cover${!this.state.isCoverImageSupported ? ' image-cover--active' : ''}`}
              style={imageStyles}
            >
              <img
                onError={this.handleImageErrored}
                src={this.state.imageSrc}
                alt={this.props.attributes.title}
              />
            </div>
          </div>
        )}
        <div className="job-list-item__content job-list-item__content--review">
          <div className="review__row-upper">
            <div className="review__row-upper--half">
              <h3 className="heading-20 review-title">
                {this.props.attributes.title}
              </h3>
              {this.state.isResponsive ? (
                <UserProjectsReviewRate
                  type={this.props.type}
                  score={this.props.attributes.score}
                  locale={this.props.locale}
                />
              ) : (
                <UserProjectsReviewMeta
                  author={this.props.attributes.author}
                  createdAt={this.props.attributes.createdAt}
                  price={price}
                  locale={this.props.locale}
                />
              )}
            </div>
            {this.state.isResponsive ? (
              <UserProjectsReviewMeta
                author={this.props.attributes.author}
                createdAt={this.props.attributes.createdAt}
                locale={this.props.locale}
                price={price}
              />
            ) : (
              <UserProjectsReviewRate
                type={this.props.type}
                score={this.props.attributes.score}
                locale={this.props.locale}
              />
            )}
          </div>
          {this.props.attributes.comment && !this.props.attributes.isPrivate && (
            <TextTruncate
              text={this.props.attributes.comment}
              truncateText="..."
              textTruncateChild={moreLink}
              containerClassName="job-list-item__description"
              line={this.state.isResponsive ? 4 : 2}
            />
          )}
          {this.props.attributes.isPrivate && (
            <p>Review is hidden</p>
          )}
        </div>
        {this.state.modalIsOpen
          && (
          <FullReviewModal
            modalIsOpen
            closeModal={this.toggleModal}
            review={this.state.review}
            showStarsRating={this.props.type !== 'modelRatings'}
          />
          )
        }
      </div>
    )
  }
}

UserReview.propTypes = {
  type: PropTypes.string.isRequired,
  attributes: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    score: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string,
    comment: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
  }),
}

UserReview.defaultProps = {
  attributes: {
    image: '',
    author: '',
    comment: '',
  },
}

export default UserReview
